import {Component, Input, OnInit} from '@angular/core';
import {AbstractComponent} from "@components";
import {TranslocoService} from "@ngneat/transloco";
import {ActivatedRoute, Router} from "@angular/router";
import {MY_TRACEY_ENTRY, MY_TRACEY_UPCOMING, ORDER_DETAILS} from "src/app/app-routing.module";
import {Country, Lookups, RaceRegistration, UserEvent} from "@model";
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-my-tracey-complete-payment',
  templateUrl: './my-entry-complete-payment.component.html',
  styleUrl: './my-entry-complete-payment.component.scss',
  standalone: false
})
export class MyEntryCompletePaymentComponent extends AbstractComponent implements OnInit {
  @Input() registration: RaceRegistration | undefined;
  @Input() countries: Country[] = [];
  @Input() languages: Lookups[] = [];

  dropdownOpened: boolean = false;

  constructor(public translocoService: TranslocoService, private clipboard: Clipboard,
              private router: Router, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
  }

  goBack() {
    const currentRoute = document.location.href;
    if (currentRoute.includes('entry')) {
      const competitorId = +this.route.snapshot.queryParams['competitorId'];
      this.router.navigate([MY_TRACEY_ENTRY],
          {queryParams: {competitorId: competitorId}}
      );
    }
    else {
      this.router.navigate([ORDER_DETAILS], {queryParamsHandling: "preserve"})
    }
  }

  copyIban(iban: string | undefined): void {
    if (iban) {
      this.clipboard.copy(iban);
    }
  }

  toggleDropdown() {
    this.dropdownOpened = !this.dropdownOpened;
  }

  payWithCard() {
    if (this.registration?.wsPayFormUrl) {
      this.goToWsPay(this.registration.wsPayFormUrl)
    }
  }

  goToWsPay(redirectUrl: string): void {
    window.location.href = redirectUrl;
  }


}
